import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import { Button, TextBox } from "../../../../../components";
import { Field, Form, Formik } from "formik";
import { formatNumber } from "../../../../../helpers/common.helper";
import TextArea from "../../../../../components/common/TextArea";
import { ReactComponent as EmptySvg } from "../../../../../assets/icons/empty-projects.svg";
import { ReactComponent as TrashSvg } from "../../../../../assets/tendering/trash.svg";
import { ReactComponent as DeleteSvg } from "../../../../../assets/admin/icons/trash.svg";
import { ReactComponent as ChevronDownSvg } from "../../../../../assets/icons/arrow-down-thin.svg";
import _, { ceil } from "lodash";
import QuotationTenderingContext from "../../QuotationTenderingContext";

const Detail = (props) => {
  const { setStep, details, setDetails, goForward, goBack } = useContext(
    QuotationTenderingContext
  );
  const [cannotContinue, setCannotContinue] = useState(false);
  const formikRef = useRef(null);
  const [subjects, setSubjects] = useState(
    details?.subjects ?? [
      {
        name: "Floor Finished Work",
        items: [
          {
            name: "Wood floor",
            symbol: "A",
            areas: [10, 10],
            unit: "sq.m.",
            material: 100,
            labor: 100,
          },
          {
            name: "Metal floor",
            symbol: "B",
            areas: [null, 100],
            unit: "sq.m.",
            material: 100,
            labor: undefined,
          },
        ],
      },
    ]
  );
  const [areas, setAreas] = useState(["Living Room", "Master Bedroom"]);
  const [subjectCollapses, setSubjectCollapses] = useState({});

  useEffect(() => {
    setStep(1);
  }, []);

  const handleValidate = ({ areas, subjects }) => {
    console.log("areas", areas);
    console.log("subjects", subjects);

    let errors = {};

    return errors;
  };

  const handleSubmit = (values, options) => {
    const getItemTotal = (item) => {
      return _.sum(item.areas) * _.sum([item.material, item.labor]);
    };

    const _subjects = values.subjects.map((subject) => {
      const price = subject.items.reduce((prev, curr) => {
        return prev + getItemTotal(curr);
      }, 0);

      const _items = subject.items.map((item) => {
        return {
          ...item,
          price: getItemTotal(item),
        };
      });

      return {
        name: subject.name,
        price,
        items: _items,
      };
    });

    setDetails((curr) => ({
      ...curr,
      areas: values.areas,
      subjects: _subjects,
    }));
    goForward();
  };

  return (
    <>
      <div className="tendering-quotation__header">
        <h3>Detail</h3>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Button
            label={"Add area"}
            variant={"secondary"}
            size={"small"}
            onClick={() => {
              const currentAreas = formikRef.current.values.areas;
              const _areas = currentAreas.concat([""]);

              formikRef.current.setFieldValue("areas", _areas);

              // * Add empty area to each subject items
              const currentSubjects = formikRef.current.values.subjects;

              for (const subject of currentSubjects) {
                for (const item of subject.items) {
                  item.areas.push(null);
                }
              }

              formikRef.current.setFieldValue("subjects", currentSubjects);
            }}
          />
          <Button
            label={"Add subject"}
            size={"small"}
            onClick={() => {
              const current = formikRef.current.values.subjects;
              const _subjects = current.concat([
                {
                  name: "",
                  items: [
                    {
                      name: "",
                    },
                  ],
                },
              ]);

              formikRef.current.setFieldValue("subjects", _subjects);
            }}
          />
        </div>
      </div>
      <div className="tendering-quotation__content">
        <Formik
          innerRef={formikRef}
          initialValues={{
            areas,
            subjects,
          }}
          validate={handleValidate}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form className="tendering-quotation__construction-detail">
              <div className="tendering-quotation__construction-detail__scroller">
                <table className="tendering-quotation__construction-detail__table">
                  <thead>
                    <tr>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__no"
                      >
                        No
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__desc"
                      >
                        Description
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__symbol"
                      >
                        Symbol
                      </th>
                      <th colSpan={values.areas.length ?? 1}>
                        Quantity in each area
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__unit"
                      >
                        Unit
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__material"
                      >
                        Material Cost
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__labor"
                      >
                        Labor Cost
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__total"
                      >
                        Total Cost
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__remark"
                      >
                        Remark
                      </th>
                      <th
                        rowSpan={2}
                        className="tendering-quotation__construction-detail__table__delete"
                      />
                    </tr>
                    <tr>
                      {values.areas.map((_a, areaIndex) => (
                        <th key={`area-${areaIndex}`}>
                          <div className="tendering-quotation__construction-detail__table__header__area">
                            <Field
                              className="tendering-quotation__construction-detail__table__header__area__field"
                              name={`areas[${areaIndex}]`}
                              data-state-fill={values.areas.length === 1}
                            />
                            {values.areas.length > 1 && (
                              <TrashSvg
                                className="tendering-quotation__construction-detail__table__header__area__delete"
                                height={18}
                                onClick={() => {
                                  let _areas = _.cloneDeep(values.areas);
                                  _areas.splice(areaIndex, 1);

                                  setFieldValue("areas", _areas);

                                  // * Clear subject item areas;
                                  let _subjects = _.cloneDeep(values.subjects);

                                  for (const _subject of _subjects) {
                                    for (const _item of _subject.items) {
                                      _item.areas.splice(areaIndex, 1);
                                    }
                                  }

                                  setFieldValue("subjects", _subjects);
                                }}
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {values.subjects?.map((_subject, subjectIndex) => {
                      let _subjectTotal = 0;
                      let _expanded =
                        subjectCollapses[`${subjectIndex}`] ?? true;

                      return (
                        <>
                          <tr key={`subject-${subjectIndex}`}>
                            <td
                              colSpan={9 + values.areas.length}
                              style={{ padding: 0 }}
                            >
                              <div className="tendering-quotation__construction-detail__table__subject">
                                <Field
                                  className="tendering-quotation__construction-detail__table__subject__field"
                                  name={`subjects[${subjectIndex}].name`}
                                />
                                <div className="tendering-quotation__construction-detail__table__subject__actions">
                                  <span
                                    className="tendering-quotation__construction-detail__table__subject__actions__action"
                                    onClick={() => {
                                      let _subjects = _.cloneDeep(
                                        values.subjects
                                      );

                                      _subjects[subjectIndex].items.push({
                                        name: "",
                                        areas: values.areas.map((_a) => null),
                                      });

                                      setFieldValue("subjects", _subjects);
                                    }}
                                  >
                                    Add item
                                  </span>
                                  {values.subjects.length > 1 && (
                                    <>
                                      <div className="tendering-quotation__construction-detail__table__subject__actions__separator" />
                                      <span
                                        className="tendering-quotation__construction-detail__table__subject__actions__action"
                                        onClick={() => {
                                          let _subjects = _.cloneDeep(
                                            values.subjects
                                          );

                                          _subjects.splice(subjectIndex, 1);

                                          setFieldValue("subjects", _subjects);
                                        }}
                                      >
                                        <DeleteSvg width={18} />
                                        Delete
                                      </span>
                                    </>
                                  )}
                                  <div className="tendering-quotation__construction-detail__table__subject__actions__separator" />
                                  <span
                                    className="tendering-quotation__construction-detail__table__subject__actions__action"
                                    onClick={() => {
                                      let _tmp = _.cloneDeep(subjectCollapses);
                                      _tmp[`${subjectIndex}`] = !_expanded;
                                      setSubjectCollapses(_tmp);
                                    }}
                                  >
                                    <ChevronDownSvg
                                      width={18}
                                      className="tendering-quotation__construction-detail__table__subject__actions__expand"
                                      data-expanded={_expanded}
                                    />
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {_expanded && (
                            <>
                              {values.subjects[subjectIndex].items.map(
                                (_item, itemIndex) => {
                                  const _itemTotal =
                                    _.sum(_item.areas) *
                                    ((_item.material ?? 0) +
                                      (_item.labor ?? 0));

                                  _subjectTotal += _itemTotal;

                                  return (
                                    <tr
                                      key={`subject-${subjectIndex}-items-${itemIndex}`}
                                    >
                                      <td className="tendering-quotation__construction-detail__table__no">
                                        {itemIndex + 1}
                                      </td>
                                      <td>
                                        <Field
                                          className="tendering-quotation__construction-detail__table__desc__field"
                                          name={`subjects[${subjectIndex}].items[${itemIndex}].name`}
                                        />
                                      </td>
                                      <td>
                                        <Field
                                          className="tendering-quotation__construction-detail__table__symbol__field"
                                          name={`subjects[${subjectIndex}].items[${itemIndex}].symbol`}
                                        />
                                      </td>
                                      {values.areas.map((_a, areaIndex) => (
                                        <td
                                          key={`subject-${subjectIndex}-items-${itemIndex}-areas-${areaIndex}`}
                                        >
                                          <Field
                                            name={`subjects[${subjectIndex}].items[${itemIndex}].areas[${areaIndex}]`}
                                            type="number"
                                          />
                                        </td>
                                      ))}
                                      <td className="tendering-quotation__construction-detail__table__unit">
                                        <Field
                                          className="tendering-quotation__construction-detail__table__unit__field"
                                          name={`subjects[${subjectIndex}].items[${itemIndex}].unit`}
                                        />
                                      </td>
                                      <td>
                                        <Field
                                          className="tendering-quotation__construction-detail__table__material__field"
                                          name={`subjects[${subjectIndex}].items[${itemIndex}].material`}
                                          type="number"
                                        />
                                      </td>
                                      <td className="tendering-quotation__construction-detail__table__labor">
                                        <Field
                                          className="tendering-quotation__construction-detail__table__labor__field"
                                          name={`subjects[${subjectIndex}].items[${itemIndex}].labor`}
                                          type="number"
                                        />
                                      </td>
                                      <td className="tendering-quotation__construction-detail__table__total__value">
                                        {formatNumber(_itemTotal)}
                                      </td>
                                      <td>
                                        <Field
                                          className="tendering-quotation__construction-detail__table__remark__field"
                                          name={`subjects[${subjectIndex}].items[${itemIndex}].remark`}
                                        />
                                      </td>
                                      <td className="tendering-quotation__construction-detail__table__delete">
                                        {values.subjects[subjectIndex].items
                                          .length > 1 && (
                                          <div
                                            className="tendering-quotation__construction-detail__table__delete__icon"
                                            onClick={() => {
                                              let _subjects = _.cloneDeep(
                                                values.subjects
                                              );

                                              _subjects[
                                                subjectIndex
                                              ].items.splice(itemIndex, 1);

                                              setFieldValue(
                                                "subjects",
                                                _subjects
                                              );
                                            }}
                                          >
                                            <TrashSvg width={18} height={18} />
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                              <tr
                                key={`subject-${subjectIndex}-subtotal`}
                                className="tendering-quotation__construction-detail__table__sub-total"
                              >
                                <td colSpan={6 + values.areas.length}>
                                  Sub total
                                </td>
                                <td style={{ borderRight: "none" }}>
                                  {formatNumber(_subjectTotal)}
                                </td>
                                <td
                                  colSpan={2}
                                  style={{ borderLeft: "none" }}
                                />
                              </tr>
                            </>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="tendering-quotation__footer">
        <Button label="Return" variant={"secondary"} onClick={goBack} />
        <Button
          label="Continue"
          // disabled={items.length === 0 || cannotContinue}
          onClick={() => {
            formikRef.current.submitForm();
          }}
        />
      </div>
    </>
  );
};

Detail.propTypes = {};

export default Detail;
